import React, { PropTypes } from 'react'
import moment from 'moment'
import ServicingCardContainer from '../../containers/servicings/servicing-card-container'
import MessageCardContainer from '../../containers/messages/message-card-container'
import QuickCreateMessageContainer from '../../containers/messages/quick-create-message-container'
import { Details, Row, Block } from '../../components/details/details'
import { Collection, Group } from '../../components/details/collection'
import { ButtonRow, Button } from '../buttons'

const WorkOrdersDetails = ({
  loading,
  id,
  backlog,
  startsAt,
  contact,
  location,
  technicians,
  description,
  servicingIds,
  unreadMessages,
  services,
  requiredEquipmentTypes,
  deleteServicing,
  markServicingAsHighPriority,
  markServicingAsLowPriority,
  children,
  urlPath,
  hasNextPage,
  onLoadNextPage,
  csvDownload,
  showInputted,
  finishedLoadingServicings = false,
}) => {
  if (loading) {
    return <p>Loading...</p>
  }

  let unreadMessageCards = null

  if (unreadMessages) {
    unreadMessageCards = unreadMessages.map((messageId) => <MessageCardContainer id={messageId} />)
  }

  return (
    <div>
      <Details
        actionType={!backlog ? 'edit' : null}
        actionLink={!backlog ? `/work-orders/${id}/details/edit` : null}
      >
        <Row>
          <Block title='location'>
            <p>{(location || {}).name}</p>
          </Block>
          <Block title='date'>
            <p>{startsAt && startsAt.format('MMMM Do, YYYY')}</p>
          </Block>
          <Block title='contact'>
            <p>{contact}</p>
          </Block>
          <Block title='Work Order'>
            <p>{id}</p>
          </Block>
          <Block title='Show Inputted?'><p>{showInputted ? 'Yes' : 'No'}</p></Block>
        </Row>
        <Row>
          <Block title='address'>
            <p>{location.address}</p>
          </Block>
          <Block title='techs'>
            <p>
              {(technicians && technicians.length > 0)
                ? (technicians.map((tech) => (
                tech.name
                )).join(', '))
                : (
                'None assigned'
                )
              }
            </p>
          </Block>
        </Row>
        <Row>
          <Block title='description'>
            <p>{description || '—'}</p>
          </Block>
          {!backlog && <Block title='messages'>
            <QuickCreateMessageContainer workOrderId={id} />
          </Block>}
        </Row>
      </Details>

      <Collection>
        <div className='list'>
          <Group title='messages' className='no-action'>
            {unreadMessageCards}
          </Group>
        </div>
      </Collection>

      <Collection
        actionType={!backlog ? 'add' : null}
        actionLink={!backlog ? `/work-orders/${id}/details/areas/create` : null}
        secondaryActionType='download'
        secondaryActionCall={backlog ? csvDownload : null}
      >
        <div className='list'>
          <Group title='areas'>
            {servicingIds.length === 0 && !finishedLoadingServicings && 'Loading...'}
            {servicingIds.map((servicingId) =>
              <ServicingCardContainer workOrderId={id} key={servicingId} id={servicingId} urlPath={urlPath} />)}

            {hasNextPage &&
              <div className='card load-more' onClick={onLoadNextPage}>
                Load more...
              </div>}
          </Group>
        </div>
      </Collection>
      {children}
    </div>
  )
}

WorkOrdersDetails.propTypes = {
  location: PropTypes.shape({ name: PropTypes.string }),
  startsAt: PropTypes.instanceOf(moment),
  contact: PropTypes.string,
  address: PropTypes.string,
  technicians: PropTypes.array,
  description: PropTypes.string,
  servicings: PropTypes.array,
  requiredEquipmentTypes: PropTypes.array
}

export default WorkOrdersDetails



// WEBPACK FOOTER //
// ./src/components/work-orders/work-orders-details.js